import { ContextParser } from '../classes/ContextParser';

const parser = new ContextParser();

onmessage = (event) => {
    parser.reset();
    event.data.scripts.forEach(script => {
        parser.parseData(script.text, script.name, true);
    });

    const {
        syntaxErrors,
    } = parser;

    postMessage({
        syntaxErrors,
    });
};
